import React from 'react';
import { List } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { responseError } from '@/utils/errors';
import { identifiableName } from '@/utils/resultsHelper';
import ErrorToast from './ErrorToast';
import ErrorToastItems from './ErrorToastItems';
import NegativeToast from './NegativeToast';

const ErrorsToast = ({
  countFirstError,
  errors,
  name,
  operation,
}) => {
  const intl = useIntl();
  const messages = errors
    .map((error) => responseError(error))
    .map((error) => error.message);
  const uniqueMessages = [...new Set(messages)];
  const displayName = name || identifiableName(errors);

  if (errors.length === 1) {
    return (<ErrorToast operation={operation} name={displayName} error={uniqueMessages[0]} />);
  }

  const values = {
    name: displayName,
    operation: intl.formatMessage({ id: operation }),
    count: countFirstError ? errors.length : errors.length - 1,
  };

  return (
    <NegativeToast className="aridhia-errors-toast" icon="times circle">
      <FormattedMessage id="toast.errors" values={values} />
      <List bulleted={uniqueMessages.length > 1}>
        <ErrorToastItems errors={uniqueMessages} />
      </List>
    </NegativeToast>
  );
};

export default ErrorsToast;
